module.exports = __webpack_public_path__ + "media/yxCenterBanner.03755c67.mp4";